module.exports = __webpack_public_path__ + "static/media/reading_submission.b948aaa2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/reading_submission.gif
// module id = 1142
// module chunks = 0